import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import {
  ManagementContainerModel,
  ManagementHouseBillModel,
  ManagementMasterBillModel,
  ManagementUpdateHouseBillModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class HouseBillsRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: PaginationSearchModel,
    isShowLoader?: boolean,
    isUsed: boolean = false,
  ): Observable<PaginatedResultModel<ManagementHouseBillModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementHouseBillModel>>(
      environment.url.freight.houseBillsManagement,
      { params },
      { isShowLoader, isUsed },
    );
  }

  public searchByMasterBillId(
    masterBillId: ManagementMasterBillModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementHouseBillModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementHouseBillModel>>(
      `${environment.url.freight.masterBillsManagement}/${masterBillId}/house-bills`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    masterBillId: ManagementMasterBillModel['id'],
    model: ManagementUpdateHouseBillModel,
    isShowLoader?: boolean,
  ): Observable<ManagementHouseBillModel> {
    return this.apiService.post<ManagementHouseBillModel>(
      `${environment.url.freight.masterBillsManagement}/${masterBillId}/house-bills`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementHouseBillModel['id'], isShowLoader?: boolean): Observable<ManagementHouseBillModel> {
    return this.apiService.get<ManagementHouseBillModel>(`${environment.url.freight.houseBillsManagement}/${id}`, null, { isShowLoader });
  }

  public update(
    id: ManagementHouseBillModel['id'],
    model: ManagementUpdateHouseBillModel,
    isShowLoader?: boolean,
  ): Observable<ManagementHouseBillModel> {
    return this.apiService.put<ManagementHouseBillModel>(`${environment.url.freight.houseBillsManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementHouseBillModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.houseBillsManagement}/${id}`, null, { isShowLoader });
  }

  public attachToContainers(
    id: ManagementHouseBillModel['id'],
    containerIds: Array<ManagementContainerModel['id']>,
    isShowLoader?: boolean,
  ): Observable<never> {
    return this.apiService.put(`${environment.url.freight.houseBillsManagement}/${id}/containers`, containerIds, null, { isShowLoader });
  }
}
